export default {
  GatewayCpe: 'Gateway Device',
  GatewayStatu: 'Gateway Status',
  Accesspoint: 'Access Point',
  Branch: 'Branch', 
  Bandwidth: 'Purchase bandwidth(bps)',
  StartTime: 'Start Time',
  ToBeActivated: 'Pending Activation', 
  InUse: 'Activating', 
  FailedToEnable: 'Failed to activate',
  InService: 'In Service',
  Deactivated: 'Suspended', 
  ServiceException: 'Service Exception',
  Disable: 'Disabled', 
  Resource: 'Resource Monitoring', 
  SearchPlaceholder: 'Search for device id / device name / gateway id / branch office', 
  Gateway: 'Gateway Instance',
  Total: (total: number) => `Total ${total} item`,
  ActiveCpe: 'Activate device',
  EnableGatewayCpe: 'Enable gateway devices',
  CpeType: 'Device type',
  CpeLabel: (num: number) => `Device ${num}`,
  SNPlaceholder: 'Please enter the device last 6 digits License ID', 
  SNRequire: 'License ID cannot be empty, please fill in as required', 
  SNConfirm: 'Device verification',
  DisableContent: ' When disabled successfully, the gateway service will be turned off. The gateway can be enabled again if needed. ',
  DisableTitle: 'Are you sure you want to disable the current gateway?',
  Retry: 'Try again',
  CpeToBeActive: 'The device has been initialized, can be activated' ,
  CpeOnline: 'Device Online',
  CpeOffline: 'Device offline', 
  CpeActiveError: 'Device activation failed please', 
  CpeActive: 'Activate Now',
  CpeName: 'Physical machine CPE',
  Isp1: 'China Mobile', 
  Isp2: 'China Telecom', 
  Isp3: 'China Unicom', 
  Isp4: 'Other', 
  ActiveSuccess: 'Activation success',
  EnableSuccess: 'Enable Success',
  DisableSuccess: 'Disabled successfully',
  ToBeConfigured: 'To be configured', 
  Deleted: 'Deleted', 
  Reset: 'Reset', 
  StopUseSuccess: 'Deactivated successfully',
  StartConfiguration: 'Deployment configuration',
  CpeOfflineEmailConfigText: 'The device is offline, if you need to reset the device configuration, you can use',
  EmailConfig: 'Mail configuration',
  SendStartEmail: 'Send start email',
  CpeStartConfig: 'Device deployment configuration',
  CpeNetworkAccess: 'Device access to the network',
  Wired: 'wired',
  Wireless: 'wireless',
  StartEmail: 'Start email',
  StartEmailError: 'Please enter the correct start email',
  SuccessSendEmailTitle: 'The device deployment email has been sent, please check it!',
  SuccessSendEmailContent1: 'Log in to the mailbox to complete the device deployment as required. After the deployment is successful, the device will switch to the online state.',
  SuccessSendEmailContent2: 'If you need to modify the configuration, please click the email configuration entry to modify and then resend the email. Do not modify it directly under Gateway Management - Network Configuration. Frequently modifying the sending in a short period of time may cause the deployment configuration to be out of sync. Please operate with caution.',
  ErrorSendEmailContent: 'The current device is online and does not support email configuration. If you need to modify the configuration, please go to Gateway Management - Network Configuration to modify it.',
  InputCpeConfig: 'Fill in the device configuration',
  Mode: 'Mode',
  TransparentMode: 'Transparent Mode',
  CommonMode: 'Common Mode',
  CpeLastTimeOnline: 'The last time the device was online',
  CpeLastTimeOffline: 'The last time the device was offline',
  CpeLastTimeOnlineStart: 'The last time the device went online',
  CpeLastTimeOnlineEnd: 'The device’s last online end time',
  CpeLastTimeOfflineStart: 'The last time the device was offline',
  CpeLastTimeOfflineEnd: 'The last time the device was offline',
  CurrentFlowLink: 'Current traffic forwarding links',
}